import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

const UiContext = createContext(null);

/** Menu drawer + search overlay state, shared by the top nav and the gallery rail. */
export const UiProvider = ({ children }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);

  const openMenu = useCallback(() => {
    setSearchOpen(false);
    setMenuOpen(true);
  }, []);
  const closeMenu = useCallback(() => setMenuOpen(false), []);
  const openSearch = useCallback(() => {
    setMenuOpen(false);
    setSearchOpen(true);
  }, []);
  const closeSearch = useCallback(() => setSearchOpen(false), []);

  const value = useMemo(
    () => ({ menuOpen, searchOpen, openMenu, closeMenu, openSearch, closeSearch }),
    [menuOpen, searchOpen, openMenu, closeMenu, openSearch, closeSearch]
  );

  return <UiContext.Provider value={value}>{children}</UiContext.Provider>;
};

export const useUi = () => useContext(UiContext);
